import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cn';
import { useAuth } from '@/lib/auth';
import { useActiveClinic } from '@/lib/activeClinic';

export function Economy() {
  const { t } = useTranslation();
  const { hasPermission } = useAuth();
  const { activeClinicId } = useActiveClinic();

  const canInvoices = Boolean(activeClinicId && hasPermission(activeClinicId, 'invoices', 'view'));
  const canPayments = Boolean(activeClinicId && hasPermission(activeClinicId, 'payments', 'view'));
  const canQuotes = Boolean(activeClinicId && hasPermission(activeClinicId, 'quotes', 'view'));

  const tabClass = ({ isActive }: { isActive: boolean }) =>
    cn(
      'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium transition',
      isActive
        ? 'border-indigo-500 text-indigo-600 dark:border-indigo-400 dark:text-indigo-300'
        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:border-gray-600 dark:hover:text-gray-300',
    );

  return (
    <div className="min-h-screen bg-page-light dark:bg-page-dark">
      <main className="py-6">
        <div className="max-w-none px-6">
          <div className="min-w-0 flex-1">
            <h2 className="text-2xl font-bold leading-7 text-gray-900 dark:text-white sm:text-3xl sm:tracking-tight">
              {t('economy.title')}
            </h2>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              {t('economy.subtitle')}
            </p>
          </div>

          <div className="mt-6 border-b border-gray-200 dark:border-gray-700">
            <nav className="-mb-px flex space-x-8" aria-label={t('economy.tabs_label')}>
              {canInvoices && (
                <NavLink to="/economy/invoices" className={tabClass}>
                  {t('economy.tabs.invoices')}
                </NavLink>
              )}
              {canPayments && (
                <NavLink to="/economy/payments" className={tabClass}>
                  {t('economy.tabs.clinio_pay')}
                </NavLink>
              )}
              {canQuotes && (
                <NavLink to="/economy/quotes" className={tabClass}>
                  {t('economy.tabs.quotes')}
                </NavLink>
              )}
            </nav>
          </div>

          <Outlet />
        </div>
      </main>
    </div>
  );
}
